// extracted by mini-css-extract-plugin
module.exports = {"deviceStatus":"DeviceStatus_deviceStatus__DumN4","indicators":"DeviceStatus_indicators__WPbOq","indicator":"DeviceStatus_indicator__2XLDD","date":"DeviceStatus_date__28q3Y"};